
import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST, APIImpl } from '../../api';
import { SendOTPRequest } from './sendotprequest';

export class SendOTPAPI extends APIImpl<SendOTPRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/send-otp-wp
        return "send-otp-wp";
    }
    
    getRequestData()
    {
        return "msisdn=" + this.getRequest().getSendOTPRequest().getMsisdn() +"&"+
               "language="+ this.getContext().getUserContext().getLanguage();
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/otp/sendotp/sendotpapi.tsx